// @flow
import React from 'react';
import LabelInput from 'components/reset/LabelInput';
import { MdArrowForward } from 'react-icons/md';

import './ResetForm.scss';

type Props = {
  onChange(e: SyntheticInputEvent<HTMLInputElement>): void,
  onReset(): Promise<*>,
  password1: string,
  password2: string,
  error: ?{
    name: string,
    payload: any,
  },
};

const errorMap = {
  FIELD_RULE: (payload: string) => {
    const rules = {
      password1: '비밀번호는 6~30자로 입력하세요.',
      password2: '새 비밀번호가 일치하지 않습니다.',
    };
    return rules[payload] || '입력한 데이터가 문제가 있습니다.';
  },
};

const printError = (error: { name: string, payload: any }) => {
  if (!errorMap[error.name]) {
    return '회원가입이 실패하였습니다. 고객센터(02-585-1342)에 문의 해주시기 바랍니다.';
  }
  return errorMap[error.name](error.payload);
};

const ResetForm = ({ onChange, onReset, password1, password2, error, onEnterKeyPress }: Props) => {
  return (
    <div className="reset-form">
      <div className="form-head">
        <h2>비밀번호 변경</h2>
      </div>
      <div className="form-contents">
        <LabelInput
          type="password"
          value={password1}
          name="password1"
          required
          label="새 비밀번호"
          placeholder="6자 이상 입력해주세요."
          onChange={onChange}
        />
        <LabelInput
          type="password"
          value={password2}
          name="password2"
          required
          label="새 비밀번호 확인"
          placeholder="다시 비밀번호를 입력해주세요."
          onChange={onChange}
          onKeyPress={onEnterKeyPress}
        />
        {error && <div className="error">{printError(error)}</div>}
        <div className="button-wrapper">
          <div className="icon-button" onClick={onReset}>
            <span>비밀번호 변경</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetForm;



// WEBPACK FOOTER //
// ./src/components/reset/ResetForm/ResetForm.js